import styled, { css } from "styled-components";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
const { color, foundation_colors, opacity, size, text } = ids || {};
const selectInputDisabled = css `
  background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_variant, opacity.ids_opacity_soft)};
  color: ${color.action.neutral.ids_color_action_neutral_base};
  border-radius: ${size.general.ids_size_general_4x}
    ${size.general.ids_size_general_4x} 0 0;
  cursor: not-allowed;
`;
export const StyledLabel = styled.label `
  pointer-events: none;
  transform-origin: left top;
  transition: 200ms ease all;
  position: absolute;
  bottom: 10px;
  padding-left: 10px;
  width: 100%;
  &.active {
    transform: translateY(-30px);
  }
`;
export const StyledSelectInput = styled.div `
  position: relative;
  display: flex;
  align-items: flex-end;
  font-size: 100%;
  line-height: 25px;
  width: 100%;
  max-width: 264px;
  height: 62px;
  padding: 10px 30px 10px 10px;
  overflow-x: hidden;
  text-shadow: none;
  border: 0;
  ${text.label.ids_textStyle_label_large_regular};
  color: ${color.action.neutral.ids_color_action_neutral_variant};
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  .input_chevron {
    position: absolute;
    right: 8px;
    bottom: 13px;
    pointer-events: none;
    transition: 100ms ease all;
    &.active {
      transform: rotate(180deg);
    }
  }

  ${({ isDisabled }) => isDisabled && selectInputDisabled}
`;
export const StyledDividerContainer = styled.div `
  display: flex;
  position: relative;
`;
export const StyledIcon = styled.div `
  position: absolute;
  top: -40px;
  left: 85%;
`;
export const HelperTextContainer = styled.div `
  margin-top: 2px;
`;
export const StyledHelperTextIcon = styled.span `
  margin-right: 5px;
`;
export const SelectInputContainer = styled.div `
  position: relative;
`;
export const SelectInputOptionList = styled.ul `
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: unset;
  border: 0 none;
`;
export const SelectInputOptionItem = styled.li `
  padding: 12px 24px 12px 8px;
  width: 100%;
  height: 48px;
  cursor: pointer;
  position: relative;
  ${text.body.ids_textStyle_body_01_regular};
  color: ${color.action.neutral.ids_color_action_neutral_base};
  background-color: ${foundation_colors.black_white.color_white};
  &:hover {
    background-color: ${foundation_colors.sand.color_sand_10};
  }

  &.active {
    background-color: ${foundation_colors.sand.color_sand_20};
    ${text.body.ids_textStyle_body_01_bold};
    &:before {
      display: block;
      position: absolute;
      content: "";
      width: 4px;
      height: 48px;
      left: 0;
      top: 0;
      background: ${color.action.primary.ids_color_action_primary_variant};
    }
  }
`;
//# sourceMappingURL=SelectInput.style.js.map